// utils
import { generateRandomCode } from 'app/utils';

function formatFurnitureCallback(furnitureIndication) {
  const { id, furnitureId, quantity, formAddOn } = furnitureIndication;

  return {
    furnitureId,
    quantity,
    formAddOn: {
      ...formAddOn,
      hasError: false,
      furnitureIndicationId: id,
      randomCode: generateRandomCode()
    }
  };
}

export { formatFurnitureCallback };
